import { Button, Flex, IconButton, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BankingConnectionSuccess } from '../../../../../../assets/images'
import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'
import { useOpenBankingAutoConnectModal } from '../../contexts/openBankingAutoConnectContext'
import * as Styled from '../LoadingModalBody/styles'

export const SuccessModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { handleCloseModal } = useOpenBankingAutoConnectModal()
  const { url: bankAccountsUrl } = useOrganizationViewUrl(reactRoute.organization.bank.getBankAccountsRoute())

  return (
    <Flex flexDirection="column" alignItems="center">
      <Styled.CloseButtonRow>
        <IconButton icon="x" onClick={handleCloseModal} />
      </Styled.CloseButtonRow>
      <BankingConnectionSuccess />
      <Space size="s16" />
      <Text weight="medium" variant="h3" alignment="center">
        {t('bank_connection.open_banking_auto_connect_modal.success_title')}
      </Text>
      <Space size="s8" />
      <Text variant="bodyLG" colorVariant="discreet" alignment="center">
        {t('bank_connection.open_banking_auto_connect_modal.success_description')}
      </Text>
      <Space size="s32" />
      <Button to={bankAccountsUrl} borderRadius="9999px" onClick={handleCloseModal}>
        {t('bank_connection.open_banking_auto_connect_modal.success_button')}
      </Button>
    </Flex>
  )
}
